import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-plus",
  "use": "icon-plus-usage",
  "viewBox": "0 0 21 21",
  "content": "<symbol viewBox=\"0 0 21 21\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-plus\">\n<line x1=\"10.5\" y1=\"0.75\" x2=\"10.5\" y2=\"20.25\" stroke-width=\"1.5\" stroke-linecap=\"round\" />\n<line x1=\"20.25\" y1=\"10.5\" x2=\"0.75\" y2=\"10.5\" stroke-width=\"1.5\" stroke-linecap=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol